export const GET_AI_GOVERNANCE_SCORE = `
  query GetAIGovernanceScore {
    getAIGovernanceScore {
      overall
      overallGrade
      actionBanner
      workloadAttribution { score grade weight }
      modelGovernance { score grade weight }
      estimateCoverage { score grade weight }
      processEfficiency { score grade weight }
    }
  }
`
